import axios from "axios";

export function fetchProfilesAction() {
    return {
        type: 'FETCH_PROFILES',
        payload: async () => {
            const response = await axios.get('/api/v2a/getProfiles');

            return response.data;
        }
    };
}